area: Area
subArea: Sub-Area
areaSubArea: Area / Sub-Area
port:
  createFromPlace:
    description: <strong>{{ portName }}</strong> is not currently listed as a port, harbour, or marina.
    confirm: Are you certain this is a location which you might reasonably expect to charter or board a yacht from?
